import { useMemo } from 'react';
import { useAbTests } from './useAbTests';
import { useClientCountryCode } from './useClientCountryCode';

export const useCommonSearchApiVariables = () => {
  const abTests = useAbTests();
  const clientCountryCode = useClientCountryCode();

  return useMemo(() => ({ abTests, clientCountryCode }), [abTests, clientCountryCode]);
};
